import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'user'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,

            ['new' + N + 'SubmitLabel']: 'Mentés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Felhasználók törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['archive' + N + 'Text']: 'Archiválás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Adminnak jelölés',
            ['removeProtection' + N + 'Text']: 'Admin jog elvétele',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',

            [n + 'UnbanEmployeeMenuLabel']: 'Tiltás visszavonása',
            [n + 'UnbanEmployeeDialogTitle']: 'Tiltás visszavonása',
            [n + 'UnbanEmployeeDialogContent']: 'Biztosan visszavonja a tiltást? A jövőben újra kaphat értesítést a jelentkezéseiről.',
            [n + 'UnbanEmployeeSubmit']: 'Visszavonás',

            [ns + 'SortRelevance']: 'Relevancia',

            loginSubmitLabel: 'Belépés',
            logoutSubmitLabel: (s) => s > 0 ? 'Kilépés ' + s + ' másodperc múlva...' : 'Kilépés',
            signupSubmitLabel: 'Regisztráció',
            forgotPasswordSubmitLabel: 'Visszaállító e-mail küldése',
            resetPasswordSubmitLabel: 'Jelszó visszaállítása',
            changeEmailSubmitLabel: 'E-mail cím megváltoztatása',
            changePasswordSubmitLabel: 'Jelszó megváltozatása',
            emailConfirmationSubmitLabel: 'E-mail cím megerősítése',
            deleteAccountLabel: 'Fiók törlése',
            deleteSubAccountLabel: 'Alfiók törlése',
            switchProfileSuggestionButton: 'Váltás erre a profilra',
            switchProfileSuggestionDismiss: 'Bezárás',
            emailConfirmationSendAgainSubmitLabel: 'Megerősítő e-mail újraküldése',
            setProfilePictureLabel: 'Profilkép beállítása',
            acceptTermsLabel: 'ÁSZF elfogadása',
            acceptPrivacyLabel: 'Adatkezelés elfogadása',
            termsWord: 'ÁSZF',
            privacyWord: 'Adatkezelés',
            signupQuestion: 'Nincs még profilod?',
            nextToSignup: 'Tovább a regisztrációhoz!',
            loginQuestion: 'Már van profilod?',
            nextToLogin: 'Tovább a belépéshez!',
            employeesMenu: 'Munkavállalók',
            employersMenu: 'Munkáltatók',

            [n + 'Overview']: 'Áttekintés',
            [n + 'OverviewActiveJobs']: 'Aktív álláshirdetés',
            [n + 'OverviewActiveInternJobs']: 'Gyakornoki hirdetés',
            [n + 'OverviewInactiveJobs']: 'Inaktív álláshirdetés',
            [n + 'OverviewDraftJobs']: 'Piszkozat',
            [n + 'OverviewUnseenApplies']: 'Új jelentkezés',
            [n + 'OverviewCredits']: 'Kredit',
            [n + 'OverviewLockedCredits']: 'Zárolt kredit',
            [n + 'OverviewAppliesAsEmployee']: 'Jelentkezések',
            [n + 'OverviewMyAppliesAsEmployee']: 'Jelentkezéseim',
            [n + 'OverviewProfileDone']: 'Munkavállalói profil',
            [n + 'OverviewProfileNeedAction']: 'Töltsd ki a profilodat',
            [n + 'OverviewForAdmin']: 'Admin',
            [n + 'OverviewAuthorTransactions']: 'Éves összesítő',
            [n + 'AuthorExportMenu']: 'Export',
            [n + 'AuthorExportSubmit']: 'Letöltés',
            [n + 'OverviewForEmployer']: 'Munkáltatóknak',
            [n + 'OverviewForEmployee']: 'Munkavállalóknak',
            [n + 'OverviewHrAssistant']: 'Próbáld ki a VLM HR asszisztensét!',


            ['get' + N + 'EmptyDescriptionTitle']: ({ isAuthor, isAdmin, post }) => {
                return isAuthor || isAdmin ?
                    `Itt a hirdetéseidet vagy a munkavállalói profilodat láthatnád` :
                    `Itt ${post?.title || 'a felhasználó'} hirdetéseit vagy a munkavállalói profilját láthadnád`
            },
            ['get' + N + 'EmptyDescriptionSubtitle']: ({ user }) => {
                return user?._id ?
                    'Ha ezt az oldalt látod az több dolgot jelenthet. Lehet, hogy a felhasználónak munkaadóként jelenleg nincs aktív álláshirdetése. Vagy munkavállalóként nincs kitöltött munkavállalói profilja.' :
                    'Ha ezt az oldalt látod az több dolgot jelenthet. Lehet, hogy a felhasználónak munkaadóként jelenleg nincs aktív álláshirdetése. Vagy munkavállalóként nincs kitöltött munkavállalói profilja. Lépj be, hogy ellenőrízni tudjuk van-e jogosultságod megtekinteni ezt a profilt!'
            },

            [name + 'LoginToUserButton']: 'Belépés a felhasználó fiókjába',
            [name + 'LoginToUserPopupClose']: 'Mégsem',

            [name + 'SaveUserTypeDialogTitle']: 'Add meg a regisztrációd típusát',
            [name + 'SaveBusinessNameDialogTitle']: 'Még nem adtad meg a üzlet nevét',

            [ns + 'FilterEmployeeCityLabel']: 'Város (munkavállalói cím)',
            [ns + 'FilterInvoiceCityLabel']: 'Város (számlázási cím)',
            [ns + 'FilterLastLoginDateFrom']: 'Utolsó bejelentkezés dátuma (tól)',
            [ns + 'FilterLastLoginDateTo']: 'Utolsó bejelentkezés dátuma (ig)',
            [ns + 'FilterCreatedDateFrom']: 'Regisztráció dátuma (tól)',
            [ns + 'FilterCreatedDateTo']: 'Regisztráció dátuma (ig)',

            [ns + 'FilterUserTypeLabel']: 'Felhasználó típusa',
            [ns + 'FilterUserTypePlaceholder']: 'Nincs megadva',
            [ns + 'FilterUserTypeOption1']: 'Munkavállaló',
            [ns + 'FilterUserTypeOption2']: 'Munkáltató',
            [ns + 'FilterProfessionsLabel']: 'Szakma',
            [ns + 'FilterProfessionsPlaceholder']: 'Nincs megadva',
            [ns + 'FilterEmployeeAgeGtLabel']: 'Kor (tól)',
            [ns + 'FilterEmployeeAgeLtLabel']: 'Kor (ig)',
            [ns + 'FilterEmployeeGenderLabel']: 'Nem',
            [ns + 'FilterEmployeeGenderOption1']: 'nő',
            [ns + 'FilterEmployeeGenderOption2']: 'férfi',
            [ns + 'FilterEmployeeGenderPlaceholder']: 'Nincs megadva',

            createSubAccountSubmitLabel: 'Alfiók létrehozása',
            [name + 'BidTextLabel']: 'Alfiók azonosító',
            [name + 'BidCopyLabel']: 'Másolás',
            [name + 'AvatarLabel']: 'Profilkép'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Felhasználók',
            ['my' + Ns + 'Menu']: 'Felhasználóim',
            ['new' + N + 'Menu']: 'Új felhasználó',
            [ns + 'Menu']: 'Felhasználók',
            ['deleted' + Ns + 'Menu']: 'Törölt felhasználók',
            ['banned' + Ns + 'Menu']: 'Tiltott felhasználók',
            ['protection' + Ns + 'Menu']: 'Adminok',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: '',
            ['archived' + Ns + 'Menu']: 'Archivált felhasználók',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['archive' + N + 'Menu']: 'Archiválás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Adminnak jelölés',
            ['removeProtection' + N + 'Menu']: 'Admin jog törlése',

            loginMenu: 'Belépés',
            signupMenu: 'Regisztráció',
            changeData: 'Adatok megváltoztatása',
            createSubAccount: 'Alfiók létrehozása',
            switchSubAccount: 'Fiók váltása',
            invoiceSettings: 'Számlázási adatok',
            employeeSettings: 'Jelentkezési adatok',
            notificationSettings: 'Értesítések',
            bannedEmployeesSettings: 'Letiltott jelentkezők',
            changeEmail: 'E-mail cím megváltoztatása',
            emailConfirmation: 'E-mail cím megerősítése',
            changePassword: 'Jelszó megváltoztatása',
            forgotPasswordMenu: 'Elfelejtett jelszó',
            deleteAccount: 'Fiók törlése',
            logoutMenu: 'Kilépés',
            profileSettings: 'Fiók beállítások',
            otherSettings: 'Egyéb',

            accountSettingsMenu: 'Beállítások',
            dashboardMenu: 'Irányítópult',
            userProfileMenu: 'Profil',
            loginMoreMenu: 'Továbbiak',

            documents: 'Dokumentumok',
            imagesAndVideos: 'Képek és videók'
        },
        messages: {
            ...messages,

            switchProfileSuggestionInfo: 'Ez a tartalom egy másik fiókodhoz tartozik:',
            ['new' + N + 'SuccessMessage']: 'Az új felhasználó mentésre került',
            ['save' + N + 'SuccessMessage']: 'A felhasználó mentésre került',
            ['delete' + N + 'Success']: 'A felhasználó törölve lett',
            ['delete' + Ns + 'Success']: 'A felhasználók törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli a felhasználót?',
            ['delete' + Ns + 'Question']: 'Biztosan törli a felhasználókat?',
            ['ban' + N + 'Success']: 'A felhasználó le lett tiltva',
            ['ban' + N + 'Question']: 'Biztos, hogy a felhasználót tiltani akarod?',
            ['archive' + N + 'Success']: 'A felhasználó archiválva lett',
            ['archive' + N + 'Question']: 'Biztos, hogy a felhasználót archiválni akarod? Nem visszavonható!',
            ['approve' + N + 'Success']: 'A felhasználó jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod a felhasználót?',
            ['protection' + N + 'Success']: 'A felhasználó adminnak jelölve',
            ['protection' + N + 'Question']: 'Biztosan adminnak jelölöd a felhasználót?',
            ['removeProtection' + N + 'Success']: 'Az admin jog törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd az admin jogot?',
            ['thereAreNo' + Ns]: 'Nincsenek felhasználók',

            [n + 'BanEmployeeSuccess']: 'A jelentkező letiltva',
            [n + 'UnbanEmployeeSuccess']: 'A letiltás visszavonva',
            [n + 'ThereAreNoBannedEmployees']: 'Nincsenek letiltott jelentkezők',

            notificationSettingsInfo: 'Miről szeretnél e-mail értesítést kapni?',
            bannedEmployeesSettingsInfo: 'Itt láthatod a letiltott jelentkezőket. A listából eltávolítva visszavonod a tiltást.',
            bannedEmployeesSettingsSuccessMessage: 'A módosítások mentésre kerültek',
            forgotPasswordSuccessMessage: 'Az üzenet el lett küldve az e-mail címedre',
            forgotPasswordInfo: 'Jelszó visszaállító hivatkozás küldése e-mailben, az új jelszó visszaállításához',
            resetPasswordSuccessMessage: 'A jelszó frissítve lett',
            changePasswordSuccessMessage: 'A jelszó frissítve lett',
            changeEmailSuccessMessage: 'Az e-mail mentésre került',
            changeDataSuccessMessage: 'Az adatai mentésre kerültek',
            changeProfilePictureSuccessMessage: 'A profilkép mentésre került',
            invoiceSettingsSuccessMessage: 'Az adatai mentésre kerültek',
            createSubAccountSuccessMessage: 'Az alfiók létrehozásra került',
            createSubAccountInfoContent: 'A fő fiókod alatt egyszerűen hozhatsz létre és kezelhetsz további alfiókokat. Minden fiókot egy helyről, egy email címmel, gyorsan és átláthatóan kezelhetsz a VLM oldalon.',
            employeeSettingsSuccessMessage: 'A jelentkezése adatai mentésre kerültek',
            notificationSettingsSuccessMessage: 'Az adatai mentésre kerültek',
            emailConfirmationSuccessMessage: 'Az e-mail cím megerősítésre került',
            emailConfirmationSendAgainSuccessMessage: 'Az e-mail megerősítő kulcs újra el lett küldve',
            emailConfirmationSendAgainInfo: 'Megerősítő e-mail küldése az e-mail cím érvényesítéséhez',
            deleteAccountSuccessMessage: 'A fiók törölve lett',
            deleteAccountQuestion: 'Biztosan törlöd a fiókot?',
            deleteAccountSuccess: 'A fiók törölve lett',
            deleteAccountInfo: 'A fiók visszaállítható 30 napig, ha a felhasználó belép a rendszerbe',
            deleteSubAccountInfo: 'Az alfiók visszaállítható 30 napig, ha a felhasználó belép ebbe az alfiókjába',
            thisIsNotYourResetPasswordKey: 'Ez a jelszó visszaállító kulcs nem ehhez a fiókhoz tartozik, lépjen ki a használatához',
            thisIsNotYourEmailConfirmationKey: 'Ez az e-mail megerősítő kulcs nem ehhez a fiókhoz tartozik, lépjen ki a használatához',

            avatarWelcomeText: 'Hello,',
            avatarWelcomeTextChristmas: 'Kellemes ünnepeket',
            [n + 'ValidationInvoiceAddress']: 'Ebben a mezőben nem szerepelhet a város és az irányítószám',

            [name + 'SaveBusinessNameDialogContent']: 'Add meg az üzlet nevét, ami megjelenik a hirdetéseidben és a profilodon!',

            [name + 'BidCopyClipboardSuccess']: 'Alfiók azonosító másolva a vágólapra',
            [name + 'BidCopyClipboardError']: 'Nem sikerült másolni az alfiók azonosítót'
        },
        routes: {
            ...routes,
            ['user' + Ns + 'Route']: '/' + ns,
            [n + 'Route']: '/' + n,
            [ns + 'Route']: '/' + ns,
            ['employeesRoute']: '/employees',
            ['employersRoute']: '/employers'
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Felhasználó',
            [ns + 'Title']: 'Felhasználók',
            ['new' + N + 'Title']: 'Új felhasználó',
            ['edit' + N + 'Title']: 'Felhasználó szerkesztése',
            ['user' + Ns + 'Title']: 'Felhasználók',
            ['userDeleted' + Ns + 'Title']: 'Törölt felhasználók',
            ['userBanned' + Ns + 'Title']: 'Véglegesen törölt felhasználók',
            ['my' + Ns + 'Title']: 'Felhasználóim',
            ['myDeleted' + Ns + 'Title']: 'Törölt felhasználóim',
            ['myBanned' + Ns + 'Title']: 'Véglegesen törölt felhasználóim',

            ['dialogDelete' + N + 'Title']: 'Felhasználó törlése',
            ['dialogBan' + N + 'Title']: 'Felhasználó tiltása',
            ['dialogArchive' + N + 'Title']: 'Felhasználó archiválása',
            ['dialogApprove' + N + 'Title']: 'Felhasználó jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Felhasználó adminnak jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Felhasználó admin jogának megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Felhasználók törlése',

            ['statusBanned' + N + 'Title']: 'Tiltva',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Admin',
            ['statusCreated' + N + 'Title']: 'Regisztrált',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt felhasználók',
            ['deleted' + Ns + 'Title']: 'Törölt felhasználók',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Adminok',
            ['lowAuthorStatus' + Ns + 'Title']: '',

            ['select' + Ns]: 'Felhasználók kiválasztása',
            ['select' + N]: 'Felhasználó kiválasztása',

            ['get' + N + 'Description']: (name) => name + ' oldala',

            loginTitle: 'Belépés a profilodba',
            accountTitle: 'Beállítások',
            changeDataTitle: 'Adatok megváltoztatása',
            changeProfilePictureTitle: 'Profilkép beállítása',
            invoiceSettingsTitle: 'Számlázási adatok',
            createSubAccountTitle: 'Alfiók létrehozása',
            employeeSettingsTitle: 'Jelentkezési adatok',
            notificationSettingsTitle: 'Értesítések',
            bannedEmployeesSettingsTitle: 'Letiltott jelentkezők',
            changeEmailTitle: 'E-mail cím megváltoztatása',
            emailConfirmationTitle: 'E-mail cím megerősítése',
            signupTitle: 'Regisztráció',
            logoutTitle: 'Kilépés',
            forgotPasswordTitle: 'Elfelejtett jelszó',
            resetPasswordTitle: 'Jelszó visszaállítása',
            changePasswordTitle: 'Jelszó megváltoztatása',
            deleteAccountTitle: 'Fiók törlése',
            profileSettingsTitle: 'Fiók beállítások',
            otherSettingsTitle: 'Egyéb',

            dialogDeleteAccountTitle: 'Fiók törlése',
            userProfileTitle: 'Profil',
            dashboardTitle: 'Irányítópult',
            acceptTermsTitle: 'ÁSZF elfogadása',
            acceptPrivacyTitle: 'Adatkezelés elfogadása',
            socialLoginTitle: 'Belépés közösségi fiókoddal',

            [name + 'LoginToUserPopupTitle']: 'Belépés a felhasználó fiókjába'
        }
    }
}
